/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PaymentStatusSuccessRouteImport } from './routes/payment-status/success'
import { Route as PaymentStatusFailureRouteImport } from './routes/payment-status/failure'
import { Route as ContractsHouseIdFlatRouteRouteImport } from './routes/contracts/$houseId/$flat/route'
import { Route as ContractsHouseIdFlatIndexRouteImport } from './routes/contracts/$houseId/$flat/index'
import { Route as ContractsHouseIdFlatPaymentRouteImport } from './routes/contracts/$houseId/$flat/payment'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentStatusSuccessRoute = PaymentStatusSuccessRouteImport.update({
  id: '/payment-status/success',
  path: '/payment-status/success',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentStatusFailureRoute = PaymentStatusFailureRouteImport.update({
  id: '/payment-status/failure',
  path: '/payment-status/failure',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractsHouseIdFlatRouteRoute =
  ContractsHouseIdFlatRouteRouteImport.update({
    id: '/contracts/$houseId/$flat',
    path: '/contracts/$houseId/$flat',
    getParentRoute: () => rootRouteImport,
  } as any)
const ContractsHouseIdFlatIndexRoute =
  ContractsHouseIdFlatIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ContractsHouseIdFlatRouteRoute,
  } as any)
const ContractsHouseIdFlatPaymentRoute =
  ContractsHouseIdFlatPaymentRouteImport.update({
    id: '/payment',
    path: '/payment',
    getParentRoute: () => ContractsHouseIdFlatRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/payment-status/failure': typeof PaymentStatusFailureRoute
  '/payment-status/success': typeof PaymentStatusSuccessRoute
  '/contracts/$houseId/$flat': typeof ContractsHouseIdFlatRouteRouteWithChildren
  '/contracts/$houseId/$flat/payment': typeof ContractsHouseIdFlatPaymentRoute
  '/contracts/$houseId/$flat/': typeof ContractsHouseIdFlatIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/payment-status/failure': typeof PaymentStatusFailureRoute
  '/payment-status/success': typeof PaymentStatusSuccessRoute
  '/contracts/$houseId/$flat/payment': typeof ContractsHouseIdFlatPaymentRoute
  '/contracts/$houseId/$flat': typeof ContractsHouseIdFlatIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/payment-status/failure': typeof PaymentStatusFailureRoute
  '/payment-status/success': typeof PaymentStatusSuccessRoute
  '/contracts/$houseId/$flat': typeof ContractsHouseIdFlatRouteRouteWithChildren
  '/contracts/$houseId/$flat/payment': typeof ContractsHouseIdFlatPaymentRoute
  '/contracts/$houseId/$flat/': typeof ContractsHouseIdFlatIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/payment-status/failure'
    | '/payment-status/success'
    | '/contracts/$houseId/$flat'
    | '/contracts/$houseId/$flat/payment'
    | '/contracts/$houseId/$flat/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/payment-status/failure'
    | '/payment-status/success'
    | '/contracts/$houseId/$flat/payment'
    | '/contracts/$houseId/$flat'
  id:
    | '__root__'
    | '/'
    | '/payment-status/failure'
    | '/payment-status/success'
    | '/contracts/$houseId/$flat'
    | '/contracts/$houseId/$flat/payment'
    | '/contracts/$houseId/$flat/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PaymentStatusFailureRoute: typeof PaymentStatusFailureRoute
  PaymentStatusSuccessRoute: typeof PaymentStatusSuccessRoute
  ContractsHouseIdFlatRouteRoute: typeof ContractsHouseIdFlatRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-status/success': {
      id: '/payment-status/success'
      path: '/payment-status/success'
      fullPath: '/payment-status/success'
      preLoaderRoute: typeof PaymentStatusSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-status/failure': {
      id: '/payment-status/failure'
      path: '/payment-status/failure'
      fullPath: '/payment-status/failure'
      preLoaderRoute: typeof PaymentStatusFailureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contracts/$houseId/$flat': {
      id: '/contracts/$houseId/$flat'
      path: '/contracts/$houseId/$flat'
      fullPath: '/contracts/$houseId/$flat'
      preLoaderRoute: typeof ContractsHouseIdFlatRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contracts/$houseId/$flat/': {
      id: '/contracts/$houseId/$flat/'
      path: '/'
      fullPath: '/contracts/$houseId/$flat/'
      preLoaderRoute: typeof ContractsHouseIdFlatIndexRouteImport
      parentRoute: typeof ContractsHouseIdFlatRouteRoute
    }
    '/contracts/$houseId/$flat/payment': {
      id: '/contracts/$houseId/$flat/payment'
      path: '/payment'
      fullPath: '/contracts/$houseId/$flat/payment'
      preLoaderRoute: typeof ContractsHouseIdFlatPaymentRouteImport
      parentRoute: typeof ContractsHouseIdFlatRouteRoute
    }
  }
}

interface ContractsHouseIdFlatRouteRouteChildren {
  ContractsHouseIdFlatPaymentRoute: typeof ContractsHouseIdFlatPaymentRoute
  ContractsHouseIdFlatIndexRoute: typeof ContractsHouseIdFlatIndexRoute
}

const ContractsHouseIdFlatRouteRouteChildren: ContractsHouseIdFlatRouteRouteChildren =
  {
    ContractsHouseIdFlatPaymentRoute: ContractsHouseIdFlatPaymentRoute,
    ContractsHouseIdFlatIndexRoute: ContractsHouseIdFlatIndexRoute,
  }

const ContractsHouseIdFlatRouteRouteWithChildren =
  ContractsHouseIdFlatRouteRoute._addFileChildren(
    ContractsHouseIdFlatRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PaymentStatusFailureRoute: PaymentStatusFailureRoute,
  PaymentStatusSuccessRoute: PaymentStatusSuccessRoute,
  ContractsHouseIdFlatRouteRoute: ContractsHouseIdFlatRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
